import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
  Divider
} from '@mui/material';
import CreateTemplate from './CreateTemplate';
import CloseIcon from '@mui/icons-material/Close';
import { handleDeleteTemplate, handleGetAllTemplate } from '.';
import LoadingOverlay from 'src/components/common/LoadingOverlay';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
interface EmailTemplate {
  id: string;
  templateName: string;
  subject: string;
  body: string;
  footer: string;
  attachments: File[];
}

const TemplateList: React.FC = () => {
  // Sample data for email templates
  const [templates, setTemplates] = useState<EmailTemplate[]>([]);

  // State for managing the dialog and selected template
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTemplate, setSelectedTemplate] =
    useState<EmailTemplate | null>(null);

  // Open dialog to edit the template
  const handleEdit = (template: EmailTemplate) => {
    setSelectedTemplate(template);
    setOpenDialog(true);
  };

  // Close dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedTemplate(null);
  };

  useEffect(() => {
    if (!openDialog) handleGetAllTemplate(setLoading, setTemplates);
  }, [openDialog]);

  return (
    <Card>
      {loading && <LoadingOverlay />}

      <Box sx={{ m: 3 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            setSelectedTemplate(null);
            setOpenDialog(true);
          }}
          sx={{ marginBottom: 4 }}
        >
          Create New Template
        </Button>
        <Grid container spacing={2}>
          {templates.map((template) => (
            <Grid item xs={12} sm={6} md={4} key={template.id}>
              <Card
                sx={{
                  minHeight: 200,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <CardContent>
                  <Typography variant="h6" color={'primary'}>
                    {template.templateName}
                  </Typography>
                  <Typography variant="subtitle1">
                    Subject: {template.subject}
                  </Typography>
                  <Typography variant="body2" noWrap>
                    {template.body.replace(/<[^>]+>/g, '')}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() =>
                      handleDeleteTemplate(
                        setLoading,
                        template.id,
                        setTemplates
                      )
                    }
                  >
                    Delete
                  </Button>
                  <Button
                    size="small"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => handleEdit(template)}
                  >
                    Edit
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Dialog for creating/editing templates */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="md"
          >
          <DialogTitle p={{xs:1, sm:3}}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography
                variant="h4"
                component="div"
                sx={{ color: 'primary.main', marginLeft: '20px' }}
              >
                {selectedTemplate ? 'Edit Template' : 'Create New Template'}
              </Typography>
              <IconButton onClick={handleCloseDialog}>
                <CloseIcon sx={{ color: '#8B0000' }} />
              </IconButton>
            </Box>
              <Divider />
          </DialogTitle>
          <DialogContent sx={{p:{xs:1, sm:3}}}>
            <CreateTemplate
              template={selectedTemplate}
              onCancel={handleCloseDialog}
            />
          </DialogContent>
        </Dialog>
      </Box>
    </Card>
  );
};

export default TemplateList;
